import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { PasswordControl } from '../../components/form-controls'

interface PasswordsProps {
    control: Control<any>
    password: any
}
export const Passwords = ({
    control,
    password
}: PasswordsProps): JSX.Element => {
    const { t } = useTranslation()

    return (
        <div className="space-y-5">
            <PasswordControl
                name="password"
                label={t('forms.common.password')}
                control={control}
                rules={{
                    required: t('forms.common.required.passwordRequired')
                }}
            />
            <PasswordControl
                showStrength={false}
                name="confirmPassword"
                control={control}
                label={t('createAccount.confirmPassword')}
                rules={{
                    required: t('forms.common.required.passwordRequired'),
                    validate: (value) =>
                        value === password ||
                        t('createAccount.passwordsMustMatch')
                }}
            />
        </div>
    )
}
